import { render, staticRenderFns } from "./receiver-harta-tidak-alih.vue?vue&type=template&id=15f1703b&"
import script from "./receiver-harta-tidak-alih.vue?vue&type=script&lang=js&"
export * from "./receiver-harta-tidak-alih.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports